import * as React from 'react';
// @ts-ignore
import AuthActions from 'auth/AuthActions';
import { FormattedMessage } from 'react-intl';
import LayerTrigger from 'components/LayerTrigger';
import LinkConstants from 'constants/LinkConstants';
import MenuItem from 'components/MenuItem';
import ModalMenuItem from 'components/ModalMenuItem';
import NavigationMenu from 'components/NavigationMenu';
// @ts-ignore
import SupportDialog from 'support/components/SupportDialog';
// @ts-ignore
import TextAppLinkDialog from 'user/components/TextAppLinkDialog';
import TextWithIcon from 'components/TextWithIcon';

type Props = {
  children?: React.ReactNode;
  isAdminOfPaidOrg: boolean;
};

const signOut = () => AuthActions.signOut();

function UserNavigationMenu(props: Props) {
  const { children, isAdminOfPaidOrg } = props;

  const menu = (
    <NavigationMenu>
      <MenuItem
        menuKey="settings"
        to="/settings"
        eventElementName="Navigation-account"
        color="thunder">
        <TextWithIcon icon="avatar" iconSize="medium" gutter="small">
          <FormattedMessage id="navigation.settings" defaultMessage="Account settings" />
        </TextWithIcon>
      </MenuItem>
      {isAdminOfPaidOrg && (
        <MenuItem
          target="_blank"
          menuKey="learning-center"
          href={LinkConstants.LEARNING_CENTER}
          eventElementName="Navigation-learning-center"
          color="thunder">
          <TextWithIcon icon="book" iconSize="medium" gutter="small">
            <FormattedMessage id="navigation.learningCenter" defaultMessage="Learning center" />
          </TextWithIcon>
        </MenuItem>
      )}
      <ModalMenuItem menuKey="help" modal={<SupportDialog />}>
        <TextWithIcon icon="question-circle" iconSize="medium" gutter="small">
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Get help" />
        </TextWithIcon>
      </ModalMenuItem>
      <ModalMenuItem menuKey="get-app" modal={<TextAppLinkDialog />}>
        <TextWithIcon icon="mobile" iconSize="medium" gutter="small">
          <FormattedMessage id="navigation.getTheApp" defaultMessage="Get the Remind app" />
        </TextWithIcon>
      </ModalMenuItem>
      <MenuItem
        menuKey="logout"
        onClick={signOut}
        eventElementName="Navigation-logOut"
        color="thunder">
        <TextWithIcon icon="sign-out" iconSize="medium" gutter="small">
          <FormattedMessage id="navigation.logout" defaultMessage="Log out" />
        </TextWithIcon>
      </MenuItem>
    </NavigationMenu>
  );

  return (
    <LayerTrigger layer={menu} placement="bottom" trigger="click">
      {children || null}
    </LayerTrigger>
  );
}

export default UserNavigationMenu;
